import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../lib/i18n";
import { api, formatApiErrorDetail } from "../lib/api";
import Seo from "../components/Seo";

export default function Login() {
  const { login, setupOwner, user } = useAuth();
  const { lang } = useLang();
  const navigate = useNavigate();
  const [needsSetup, setNeedsSetup] = useState(null);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("argalialtai@yandex.ru");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role) navigate("/admin");
  }, [user, navigate]);

  useEffect(() => {
    api.get("/auth/setup-status")
      .then((r) => setNeedsSetup(Boolean(r.data?.needs_setup)))
      .catch((err) => {
        setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        setNeedsSetup(false);
      });
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      if (needsSetup) {
        await setupOwner({ name, email, password, phone });
      } else {
        await login(email, password);
      }
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-transparent border-b border-argali-sandstone/30 py-3 text-argali-ivory placeholder-argali-sandstone/40 focus:border-argali-bronze outline-none transition-colors";

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center px-5 grain" style={{ background: "#11110F" }}>
      <Seo path="/login" lang={lang} title={lang === "ru" ? "Вход" : "Sign in"} noIndex />
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <img src="/brand/argali_emblem_ru.png" alt="Логотип АРГАЛИ" width="543" height="501" className="h-16 w-auto" />
          <span className="font-serif text-3xl tracking-[0.22em] text-argali-ivory mt-4">АРГАЛИ</span>
          <p className="eyebrow mt-2">
            {needsSetup
              ? (lang === "ru" ? "Первичная настройка владельца" : "Owner setup")
              : (lang === "ru" ? "Вход в панель" : "Dashboard sign in")}
          </p>
        </div>

        {needsSetup === null ? (
          <p className="text-center text-argali-sandstone/60">{lang === "ru" ? "Проверка…" : "Checking…"}</p>
        ) : (
          <form onSubmit={submit} className="space-y-6">
            {needsSetup && (
              <>
                <input required data-testid="setup-name" className={field} placeholder={lang === "ru" ? "Ваше имя" : "Your name"} value={name} onChange={(e) => setName(e.target.value)} />
                <input data-testid="setup-phone" className={field} placeholder={lang === "ru" ? "Телефон (необязательно)" : "Phone (optional)"} value={phone} onChange={(e) => setPhone(e.target.value)} />
              </>
            )}
            <input required type="email" data-testid="login-email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
            <input required type="password" minLength={needsSetup ? 12 : undefined} data-testid="login-password" className={field} placeholder={lang === "ru" ? "Пароль" : "Password"} value={password} onChange={(e) => setPassword(e.target.value)} />
            {needsSetup && <p className="text-xs text-argali-sandstone/50">{lang === "ru" ? "Пароль — минимум 12 символов. Он не хранится в открытом виде." : "Use at least 12 characters. The password is not stored in plain text."}</p>}
            {error && <p className="text-red-400 text-sm" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="login-submit" className="btn-bronze w-full justify-center">
              {loading ? "…" : needsSetup
                ? (lang === "ru" ? "Создать аккаунт владельца" : "Create owner account")
                : (lang === "ru" ? "Войти" : "Sign in")}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
